import { useTheme, useMediaQuery } from '@material-ui/core';

export const useResponsive = () => {
  const theme = useTheme();
  
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600-959px
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // >= 960px
  const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg')); // >= 1280px
  
  // Helper para detectar se é touch device
  const isTouch = 'ontouchstart' in window;
  
  // Helper para orientação
  const isPortrait = window.matchMedia('(orientation: portrait)').matches;
  const isLandscape = !isPortrait;
  
  // Breakpoint atual
  const breakpoint = isLargeDesktop 
    ? 'xl' 
    : isDesktop 
    ? 'lg' 
    : isTablet 
    ? 'md' 
    : 'sm';
  
  return {
    // Estados básicos
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    
    // Helpers úteis
    isTouch,
    isPortrait,
    isLandscape,
    breakpoint,
    
    // Combinações úteis
    isMobileOrTablet: isMobile || isTablet,
    isTabletOrDesktop: isTablet || isDesktop,
    
    // Helpers para UI
    gridColumns: isMobile ? 1 : isTablet ? 2 : isDesktop ? 3 : 4,
    spacing: isMobile ? 1 : isTablet ? 2 : 3,
    cardVariant: isMobile ? 'elevation' as const : 'outlined' as const,
  };
};